/**
 * Canonical identity for the SuperAgent across the platform.
 *
 * The SuperAgent has no row in the `agents` table — it's the workspace-mode
 * generalist that handles any chat where no specialist is picked. We still
 * need a stable identifier so chats can be persisted, queried, and grouped
 * in the UI consistently.
 *
 * `chats.agentId` is a free-form text column (no FK), so a reserved UUID
 * sentinel works without any schema change.
 *
 * Historical data may carry the legacy values `"super-agent"`, `"0"`, or
 * `0` (the previous string/number sentinels) — `isSuperAgentId` accepts all
 * of them so existing chats keep grouping correctly during the rollout.
 */
export const SUPER_AGENT_ID = "00000000-0000-0000-0000-000000000001";

/**
 * Returns true if the given identifier refers to the SuperAgent — including
 * the new canonical UUID and the legacy sentinels still present in older
 * chat rows.
 */
export function isSuperAgentId(
  id: string | number | null | undefined,
): boolean {
  if (id === null || id === undefined) return false;
  if (typeof id === "number") return id === 0;
  return (
    id === SUPER_AGENT_ID ||
    id === "super-agent" ||
    id === "0"
  );
}
